/*
 * Copyright (c) 2026. Orion Analytics. All Rights Reserved
 */

import {
    Newspaper,
    TrendingUp,
    PlayCircle,
    X
} from "lucide-react";
import {useEffect, useState} from "react";
import {fetchAnnouncements,fetchMarketCommentary} from "../../api";

export default function HomeSidebarHub() {
    const [announcements, setAnnouncements] = useState([]);
    const [selected, setSelected] = useState(null);
    const [commentary, setCommentary] = useState(null);
    const [showCommentary, setShowCommentary] = useState(false);

    useEffect(() => {

        const loadAnnouncements = async () => {

            try {

                const data = await fetchAnnouncements();
                setAnnouncements(data || []);

            } catch (err) {

                console.error(err);

            }

        };

        const loadCommentary = async () => {

            try {

                const data = await fetchMarketCommentary();
                setCommentary(data);

            } catch (err) {

                console.error(err);

            }

        };

        loadAnnouncements();
        loadCommentary();

    }, []);

    return (

        <div
            className="
                hidden
                xl:block
                fixed
                right-6
                top-36
                w-80
                z-40
            "
        >

            <div
                className="
                    bg-white
                    rounded-3xl
                    border
                    border-slate-200
                    shadow-2xl
                    overflow-hidden
                "
            >

                {/* Header */}

                <div
                    className="
                        px-6
                        py-4
                        bg-gradient-to-r
                        from-blue-800
                        to-indigo-600
                        text-white
                    "
                >
                    <h3 className="font-bold text-white">
                        Orion Live Hub
                    </h3>

                    <p className="text-xs opacity-80 mt-1">
                        Research • Commentary • Platform
                    </p>
                </div>

                {/* Research */}

                <div className="p-5 border-b">

                    <div className="flex items-center gap-2 mb-3">

                        <Newspaper
                            size={18}
                            className="text-blue-600"
                        />

                    <div>

                        <h4 className="font-semibold">
                            Latest Research
                        </h4>

                        {/*<p className="text-xs text-slate-500">*/}
                        {/*    {announcements.length} research notes*/}
                        {/*</p>*/}

                    </div>

                    </div>


                    <div className="space-y-2">

                        {announcements.slice(0, 4).map((item, idx) => (

                            <button
                                key={idx}
                                onClick={() => setSelected(item)}
                                className="
                                    block
                                    w-full
                                    text-left
                                    text-sm
                                    text-slate-200
                                    hover:text-blue-600
                                    hover:bg-slate-100
                                    rounded-lg
                                    px-2
                                    py-2
                                    transition
                                "
                            >
                                <div className="line-clamp-2">
                                    {item.title}
                                </div>
                            </button>

                        ))}

                    </div>
                </div>

                {/* Commentary */}

                <div className="p-5 border-b">

                    <div className="flex items-center gap-2 mb-3">

                        <TrendingUp
                            size={18}
                            className="text-emerald-600"
                        />

                        <div>

                            <h4 className="font-semibold">
                                Market Outlook
                            </h4>

                            {/*<p className="text-xs text-slate-500">*/}
                            {/*    Latest market commentary*/}
                            {/*</p>*/}

                        </div>

                    </div>

                    {commentary && (

                        <>

                            <div
                                className="
                                    text-sm
                                    font-semibold
                                    text-slate-800
                                    line-clamp-2
                                    mb-2
                                "
                            >
                                {commentary.title}
                            </div>

                            <div
                                className="
                                    text-xs
                                    text-slate-500
                                    line-clamp-3
                                    mb-3
                                "
                            >
                                {commentary.headline}
                            </div>

                            <button
                                onClick={() => setShowCommentary(true)}
                                className="
                                    block
                                    w-full
                                    text-center
                                    text-sm
                                    text-slate-200
                                    hover:text-blue-600
                                    hover:bg-slate-100
                                    rounded-lg
                                    px-2
                                    py-2
                                    transition
                                "
                            >
                                Read Full Outlook →
                            </button>

                        </>

                    )}

                </div>

                {/* Demo */}

                {/*<div className="p-5">*/}

                {/*    <div className="flex items-center gap-2 mb-3">*/}

                {/*        <PlayCircle*/}
                {/*            size={18}*/}
                {/*            className="text-purple-600"*/}
                {/*        />*/}

                {/*        <h4 className="font-semibold">*/}
                {/*            Platform Tour*/}
                {/*        </h4>*/}

                {/*    </div>*/}

                {/*    <button*/}
                {/*        className="*/}
                {/*            w-full*/}
                {/*            bg-slate-900*/}
                {/*            hover:bg-slate-800*/}
                {/*            text-white*/}
                {/*            rounded-xl*/}
                {/*            py-3*/}
                {/*            font-medium*/}
                {/*            transition*/}
                {/*        "*/}
                {/*    >*/}
                {/*        ▶ Watch Demo*/}
                {/*    </button>*/}
                {/*</div>*/}

            </div>
            {
            selected && (

                <div
                    className="
                        fixed
                        inset-0
                        top-36
                        bg-black/50
                        z-[100]
                        flex
                        items-center
                        justify-center
                        p-6
                    "
                    onClick={() => setSelected(null)}
                >

                    <div
                        className="
                            bg-white
                            rounded-3xl
                            shadow-2xl
                            w-full
                            max-w-4xl
                            max-h-[85vh]
                            overflow-y-auto
                            p-8
                        "
                        onClick={(e) => e.stopPropagation()}
                    >

                        <div className="flex justify-between mb-6">

                            <h2
                                className="
                                    text-2xl
                                    font-bold
                                    text-slate-900
                                "
                            >
                                {selected.title}
                            </h2>

                        <button
                            onClick={() => setSelected(null)}
                            className="
                                flex
                                items-center
                                justify-center
                                w-9
                                h-9
                                rounded-full
                                bg-slate-100
                                hover:bg-red-100
                                text-slate-500
                                hover:text-red-600
                                transition
                                flex-shrink-0
                            "
                        >
                            <X size={18} />
                        </button>

                        </div>

                        <div
                            className="
                                prose
                                max-w-none
                            "
                            dangerouslySetInnerHTML={{
                                __html: selected.content
                            }}
                        />

                    </div>

                </div>

            )
            }
            {
            showCommentary && commentary && (

                <div
                    className="
                        fixed
                        inset-0
                        top-36
                        bg-black/50
                        z-[100]
                        flex
                        items-center
                        justify-center
                        p-6
                    "
                    onClick={() => setShowCommentary(false)}
                >

                    <div
                        className="
                            bg-white
                            rounded-3xl
                            shadow-2xl
                            w-full
                            max-w-4xl
                            max-h-[85vh]
                            overflow-y-auto
                            p-8
                        "
                        onClick={(e) => e.stopPropagation()}
                    >

                        <div className="flex justify-between mb-6">

                            <h2
                                className="
                                    text-2xl
                                    font-bold
                                    text-slate-900
                                "
                            >
                                {commentary.title}
                            </h2>

                            <button
                                onClick={() => setShowCommentary(false)}
                                className="
                                    flex
                                    items-center
                                    justify-center
                                    w-9
                                    h-9
                                    rounded-full
                                    bg-slate-100
                                    hover:bg-red-100
                                    text-slate-500
                                    hover:text-red-600
                                    transition
                                "
                            >
                                <X size={18}/>
                            </button>

                        </div>

                        <div
                            className="
                                prose
                                max-w-none
                            "
                            dangerouslySetInnerHTML={{
                                __html: commentary.content
                            }}
                        />

                    </div>

                </div>

            )
            }
        </div>
    );
}
